import { useEffect } from "react"
import { useGetCommitteeLink } from "./useCommitteeStatus"

export const CommitteeLinkRedirection = ({ close }: { close: () => void }) => {
  const {
    data: { link } = {},
  } = useGetCommitteeLink()

  useEffect(() => {
    if (link) {
      setTimeout(() => {
        window.open(link, "_blank")
        close()
      }, 0)
    }
  }, [link, close])

  return null
}
